import { useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "./ui/dialog";
import { StarRating } from "./StarRating";
import { REVIEW_CRITERIA } from "../lib/constants";
import { Star } from "lucide-react";

export const ReviewDialog = ({ jobId, transporterName, onDone }) => {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [scores, setScores] = useState({ overall: 0, punctuality: 0, communication: 0, vehicle_condition: 0, careful_handling: 0, professionalism: 0 });
  const [comment, setComment] = useState("");

  const submit = async () => {
    if (Object.values(scores).some((v) => v < 1)) { toast.error("Please rate all categories"); return; }
    setSaving(true);
    try {
      await api.post(`/transport-jobs/${jobId}/review`, { ...scores, comment });
      toast.success("Review submitted");
      setOpen(false);
      onDone && onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to submit review");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" className="rounded-none bg-accent text-foreground hover:bg-accent/90" data-testid={`review-btn-${jobId}`}>
          <Star className="h-4 w-4 mr-1" /> Review transporter
        </Button>
      </DialogTrigger>
      <DialogContent className="rounded-none max-w-md max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle className="font-display">Review {transporterName}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          {REVIEW_CRITERIA.map((c) => (
            <div key={c.key} className="flex items-center justify-between">
              <span className="text-sm font-medium">{c.label}</span>
              <StarRating value={scores[c.key]} onChange={(n) => setScores({ ...scores, [c.key]: n })} testid={`score-${c.key}`} />
            </div>
          ))}
          <div>
            <Label className="label-caps">Written review</Label>
            <Textarea value={comment} onChange={(e) => setComment(e.target.value)} rows={3} className="rounded-none mt-1" placeholder="Share your experience…" data-testid="review-comment" />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={submit} disabled={saving} className="rounded-none bg-primary hover:bg-primary/90" data-testid="submit-review-btn">{saving ? "Submitting…" : "Submit review"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
